// @flow
import React, {Component} from 'react';
import {
  StyleSheet,
  View,
  Image,
  Text,
  Linking,
  TouchableOpacity,
  ScrollView,
  Platform,
} from 'react-native';

import {GradientPage, FullButton, Checkbox} from '../../../components/common';
import {PageTitle} from '../../../components/signUp';
import I18n from '../../../lib/i18n';
import theme from '../../../theme-config';
import {setIsESimCompatibleToAsyncStorage} from '../../../modules/ESim/eSIM';
import EsimCompatiblePanel from './components/EsimCompatiblePanel';

const ESIM_COMPATIBLE_URL =
  'https://www.wizzee.fr/support/#/articles/les-mobiles-compatibles-esim----e5e53a8b-42ff-4617-82f6-1ef70b8bb4b9';

class ESimCheck extends Component<Props, State> {
  styles = getStyles();

  state = {
    isCkeckedEsimCompatible: false,
    isEsimCompatiblePanelVisible: false,
    isEsimCompatibleUrlError: false,
    isEsimCompatible: false,
  };

  goToNextPage = () => {
    const {nextPage} = this.props;
    if (this.props.route.params?.simSwap) {
      this.props.goToSelectSubscriptionToSimSwap();
    } else {
      this.props.goTo(nextPage);
    }
  };

  toggleConfirmEsimCompatible = () => {
    this.setState(prevState => ({
      isCkeckedEsimCompatible: !prevState.isCkeckedEsimCompatible,
    }));
  };

  checkPhoneIsEsimCompatible = () => {
    setIsESimCompatibleToAsyncStorage()
      .then(isESimCompatible => {
        this.setState({
          isEsimCompatible: isESimCompatible,
          isEsimCompatiblePanelVisible: true,
        });
        
        // Hide automatically after 4 seconds
        setTimeout(() => this.setState({isEsimCompatiblePanelVisible: false}), 4000);
      })
      .catch(err => {
        this.setState({
          isEsimCompatibleUrlError: true,
          isEsimCompatiblePanelVisible: true,
        });
        setTimeout(() => this.setState({isEsimCompatiblePanelVisible: false}), 4000);
      });
  };

  openEsimCompatibleUrl = () => {
    Linking.canOpenURL(ESIM_COMPATIBLE_URL).then(canOpen => {
      if (canOpen) {
        Linking.openURL(ESIM_COMPATIBLE_URL);
      }
    });
  };

  render() {
    const styles = this.styles;
    return (
      <GradientPage>
        <View style={styles.outerContainer}>
          <EsimCompatiblePanel
            isVisible={this.state.isEsimCompatiblePanelVisible}
            isEsimCompatible={this.state.isEsimCompatible}
            isError={this.state.isEsimCompatibleUrlError}
          />

          <View style={styles.scrollWrapper}>
            <PageTitle
              title={I18n.t('SignUp.ESimCheck.title')}
              style={styles.title}
            />
            <ScrollView showsVerticalScrollIndicator={false}>
              <View style={styles.imageZone}>
                <Image
                  style={styles.imageStyle}
                  source={theme.requiredToSignUp.phone.image}
                  resizeMode="contain"
                />
              </View>

              <View style={styles.descriptionZone}>
                <Text style={styles.descriptionStyle}>
                  {I18n.t('SignUp.ESimCheck.description')}
                </Text>
              </View>

              <View style={styles.mobileCompatibilityZone}>
                <TouchableOpacity
                  style={styles.linkMargin}
                  onPress={this.openEsimCompatibleUrl}>
                  <Text style={styles.mobileCompatibilityTextStyle}>
                    {I18n.t('SignUp.ESimCheck.compatibleMobilesText')}
                  </Text>
                </TouchableOpacity>

                {Platform.OS !== 'ios' && (
                  <FullButton
                    text={I18n.t('SignUp.ESimCheck.buttonCheckEsimCompatibility')}
                    onPress={this.checkPhoneIsEsimCompatible}
                    style={styles.checkCompatibilityButtonStyle}
                    textStyle={styles.checkCompatibilityTextStyle}
                  />
                )}
              </View>
            </ScrollView>
          </View>

          <View style={styles.footer}>
            <Checkbox
              style={styles.checkBoxStyle}
              labelStyle={styles.checkBoxLabelStyle}
              onPress={this.toggleConfirmEsimCompatible}
              isChecked={this.state.isCkeckedEsimCompatible}
              text={I18n.t('SignUp.ESimCheck.confirmEsimText')}
            />
            <FullButton
              text={I18n.t('SignUp.ESimCheck.buttonContinue')}
              onPress={this.goToNextPage}
              style={styles.button}
              textStyle={styles.buttonText}
              disabled={!this.state.isCkeckedEsimCompatible}
            />
          </View>
        </View>
      </GradientPage>
    );
  }
}

function getStyles() {
  return StyleSheet.create({
    outerContainer: {
      flex: 1,
    },
    scrollWrapper: {
      flex: 7,
      marginTop: 35,
      marginHorizontal: 25,
    },
    title: {
      marginTop: 16,
    },
    imageZone: {alignItems: 'center'},
    imageStyle: {marginVertical: 40, width: 110, height: 110},
    descriptionStyle: {
      color: theme.signUpInputTextColor,
      textAlign: 'center',
      fontSize: 16,
      lineHeight: 22,
    },
    mobileCompatibilityZone: {alignItems: 'center', marginTop: 20},
    linkMargin: {marginTop: 2, marginBottom: 40},
    mobileCompatibilityTextStyle: {
      color: theme.signUpInputTextColor,
      textDecorationLine: 'underline',
    },
    checkCompatibilityButtonStyle: {
      marginBottom: 40,
    },
    checkCompatibilityTextStyle: {
      fontSize: 15,
      fontWeight: '600',
    },
    footer: {
      flex: 1,
      borderTopWidth: 1,
      borderTopColor: 'rgba(255,255,255,0.1)',
      paddingTop: 20,
      paddingBottom: Platform.OS === 'ios' ? 30 : 10,
    },
    checkBoxStyle: {marginHorizontal: 25},
    checkBoxLabelStyle: {color: theme.signUpInputTextColor, fontSize: 14},
    button: {marginHorizontal: 20, marginTop: 20},
    buttonText: {fontSize: 16, fontWeight: '600'},
  });
}

export default ESimCheck;